module.exports = __webpack_public_path__ + "static/ace_rewards_prefooter-64d674986043b2c8a977aec06495be01.jpg";